// removed by extract-text-webpack-plugin
module.exports = {"avatar":"theme__avatar__1C3r3Vka","image":"theme__image__1izFW7Yy","letter":"theme__letter__hkoQC6XE"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-toolbox/lib/avatar/theme.css
// module id = 932
// module chunks = 0